import EdisonFormSelectItem from "../EdisonFormSelectItem";

const tableTypes: EdisonFormSelectItem[] = [
  { id: 0, displayName: "Standard" },
  { id: 1, displayName: "Periodic" },
  { id: 2, displayName: "Task" },
];

export default tableTypes;
